import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Select, message } from "antd";
import "../../index.css";
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../common/customLoader";
import APICaller from "../../utils/APICaller";

const SwitchRole = (props) => {
  const navigate = useNavigate();
  const slsRole = secureLocalStorage.getItem("role");
  const slsLIUId = secureLocalStorage.getItem("lIUId");
  const slsToken = secureLocalStorage.getItem("accessToken");
  const { role } = props;
  const [file, setFile] = useState();
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const formRef = useRef(null);

  /*begin::getRoles will fetch the list of Roles*/
  const getRoles = async () => {
    const endpoint = "/roles/fetchWithoutPagination";
    const method = "GET";
    const payload = {};

    await APICaller(slsRole, slsToken, endpoint, method, payload)
      .then((response) => {
        const temp = [];
        response?.map((role, index) => {
          temp.push({ label: role?.name, value: role?.name?.toLowerCase() });
        });
        setRoles(temp);
      })
      .catch((error) => {});
  };
  /*end::getRoles will fetch the list of Roles*/

  const handleSubmit = (event) => {
    event.preventDefault();
    setShowLoader(true);

    const headers = {
      role: slsRole,
    };
    const endpoint = "/updateRole";
    const method = "POST";
    const payload = {
      lIUId: slsLIUId,
      selectedRole,
    };

    APICaller(slsRole, slsToken, endpoint, method, payload, headers)
      .then((response) => {
        setShowLoader(false);

        resetForm();
        if (response) {
          const parseJson = JSON.parse(response);
          secureLocalStorage.setItem("role", parseJson?.role);
          message.success(parseJson?.message);
          secureLocalStorage.setItem("switchRole", true);

          navigate("/dashboard");
        }
      })
      .catch((error) => {
        message.error("There was an error!" + error);
        setShowLoader(false);
        // if (error.data && error.data.message) {
        //   setErrors(error.data.message);
        // } else {
        //   message.error("An error occurred while saving the settings");
        // }
      });
  };

  const resetForm = () => {
    if (formRef.current) {
      formRef.current.reset();
    }
    setSelectedRole(undefined);
  };

  useEffect(() => {
    getRoles();
  }, []);
  return (
    <div className="all-content switchRoleContainer">
      <div className="all-table-holder">
        <CustomLoader showLoader={showLoader} />
        <form onSubmit={handleSubmit} ref={formRef}>
          <div className="">
            <Select
              showSearch
              allowClear
              options={roles}
              value={selectedRole} // Controlled value
              placeholder="Select an option"
              className="w-100"
              onChange={(val) => {
                setSelectedRole(val);
              }}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  ?.toLowerCase()
                  .includes(input?.toLowerCase())
              }
            ></Select>
          </div>
          <div className="buttonsContainer">
            <button
              className="ant-btn ant-btn-primary submit-btn border-0 me-4 rounded"
              type="submit"
              role="button"
              aria-expanded="false"
              aria-controls="collapseContent"
            >
              Update
            </button>
            <button
              type="button"
              className="ant-btn ant-btn-primary submit-btn border-0 me-4 rounded"
              onClick={resetForm}
            >
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SwitchRole;
